export default "__VITE_ASSET__828e7f5c__"